module.exports = __webpack_public_path__ + "static/media/screwing.ec51dc6e.mp4";